export default "__VITE_ASSET__CW8l6PQq__"